export default __webpack_public_path__ + "static/media/locaition-icon.ce384e2e.png";